import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerDto } from "src/app/shared/models/DTO/customer-dto";
import { GuestWeeklyMetric } from "src/app/shared/models/Guest.dto";

@Component({
	selector: "app-customer-dashboard-widget",
	templateUrl: "./customer-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class CustomerDashboardWidgetComponent implements OnInit {
	guestWeeklyMetric: GuestWeeklyMetric;
	guestRev: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenue.subscribe((data) => {
			if (data && data.key) {
				this.guestWeeklyMetricGet(data.key);
			}
		});
	}

	async guestWeeklyMetricGet(venueKey) {
		const report: any[] = [
			{
				day: "undefined",
				count: 0,
			},
		];
		const resp = await this.focuslink.customerGetAll(venueKey, false);
		const customerDtoList: CustomerDto[] = resp.records.map((i) => new CustomerDto(i));
		this.guestWeeklyMetric = new GuestWeeklyMetric();
		customerDtoList.forEach((cust) => {
			if (Object.keys(cust.firstVisitDate).length === 0) {
			} else {
				if (this.app.moment(cust.firstVisitDate).isAfter(this.app.moment().add(-7, "days"))) {
					this.guestWeeklyMetric.totalNewGuestRevenue += +cust.totalRevenue;
					this.guestWeeklyMetric.totalNewGuests += 1;
				}
			}

			this.guestWeeklyMetric.totalGuestRevenue += +cust.totalRevenue;
			this.guestWeeklyMetric.totalGuests += 1;
		});
	}
}
